<script>
import { Modal } from 'ant-design-vue';
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    prefixCls: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  components: { Modal },
  mounted() {},
  methods: {},
  render() {
    const props = {
      props: { ...this.$attrs },
      on: { ...this.$listeners },
    };
    if (!this.showTitle) {
      // this.$slots.title = undefined;
    }
    return (
      <div>
        <Modal {...props} class={[this.prefixCls, 'ant-pro-modal']}>
          {Object.keys(this.$slots).map((name) => (
            <template slot={name}>{this.$slots[name]}</template>
          ))}
        </Modal>
      </div>
    );
  },
  renderError(h, err) {
    return h('pre', { style: { color: 'red' } }, err.stack);
  },
};
</script>
<style lang="less" scoped></style>
